import {subscribe} from './events';

const isToggleOrSlide = element => {
  const {jQuery:$} = global;
  if(!$) return false;
  const $el = $(element);
  return $el.data('toggle') !== undefined || $el.data('slide') !== undefined
}

export default function anchorScroll(
  smooth = 6,
  completeThreshhold = .5
){
  let movementIdCount = 0;

  const scrollToElement = element=>{
    const movementId = ++movementIdCount;
    let currentOffset = document.scrollingElement.scrollTop;
    const navbar = document.querySelector('.navbar-fixed-top');

    const tick = ()=>{

      const maxScroll = document.scrollingElement.scrollHeight - window.innerHeight;

      let targetOffset = element.getBoundingClientRect().top + document.scrollingElement.scrollTop;

      if(navbar){
        targetOffset -= navbar.getBoundingClientRect().height;
      }

      if(targetOffset > maxScroll){
        targetOffset = maxScroll;
      }

      currentOffset += (targetOffset - currentOffset) / smooth;

      if(movementId === movementIdCount && Math.abs(targetOffset - currentOffset) > completeThreshhold){
        document.scrollingElement.scrollTop = currentOffset;
        requestAnimationFrame(tick);
      }else{
        document.scrollingElement.scrollTop = targetOffset;
      }

    }

    requestAnimationFrame(tick);
  }

  const listeners = Array.from(document.querySelectorAll('a[href*="#"]:not([href$="#"])')).map(anchor => {
    if (
      location.pathname.replace(/^\//,'') === anchor.pathname.replace(/^\//,'') &&
      location.hostname === anchor.hostname &&
      !isToggleOrSlide(anchor)
    ){
      return subscribe(anchor,'click',e=>{
        const target = document.querySelector(anchor.hash) || document.querySelector(`[name=${anchor.hash.slice(1)}]`);
        if(target){
          e.preventDefault();
          e.stopPropagation();
          scrollToElement(target);
        }
      });
    }
  }).filter(listener => Boolean(listener));

  return ()=>{
    listeners.forEach(listener=>listener());
  }
}